import { reissueAccountBadgesBulkActionName, } from '../../../../backend/features/badges/shared';
import { AccountBadgeReissueBulkActionDialog } from '../../../../ui/features/badge-management/components/AccountBadgeReissueBulkActionDialog';
import { AccountBadgeContext, AccountBadgeContextProvider } from '../../../../ui/features/badge-management/contexts/AccountBadgeContext';
import { AccountContext, AccountContextProvider } from '../../../../ui/features/badge-management/contexts/AccountContext';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { getFilterForBulkAction } from '../../../../ui/util/getFilterForBulkAction';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
import React from 'react';
export function useAccountBadgeReissueBulkAction(options) {
    const { t } = useBadgingTranslation();
    const accountContext = React.useContext(AccountContext);
    const accountBadgeContext = React.useContext(AccountBadgeContext);
    const handleReissueAccountBadgesBulkAction = (badgeId, accountBadgesToReissue, onSuccess, onClose) => {
        var _a;
        launchBulkAction({
            title: t('badges.badgeDetails.accountBadgeTable.reissueDialog.progress'),
            type: reissueAccountBadgesBulkActionName,
            params: { badgeId, accountBadgesToReissue },
            runSync: (_a = options === null || options === void 0 ? void 0 : options.runSync) !== null && _a !== void 0 ? _a : false,
            onClose: ({ status, processedCount }) => {
                if (status === 'finished') {
                    showAlertSnackbar({
                        horizontalPosition: 'center',
                        type: 'success',
                        verticalPosition: 'bottom',
                        autoHideDuration: 2000,
                        message: t('badges.badgeDetails.accountBadgeTable.reissueDialog.successMessage', {
                            count: processedCount,
                        }),
                    });
                    onSuccess();
                }
                else {
                    onClose === null || onClose === void 0 ? void 0 : onClose();
                }
            },
        });
    };
    const handleReissueAccountBadgesBulkActionDialog = (badgeId, appliedStorageFilters, accountBadgeSelectedIds, onSuccess, onClose) => {
        const bulkActionFilters = getFilterForBulkAction(accountBadgeSelectedIds, appliedStorageFilters);
        showCustomDialog({
            maxWidth: 'md',
            content: (close) => {
                return (React.createElement(AccountContextProvider, Object.assign({}, accountContext),
                    React.createElement(AccountBadgeContextProvider, Object.assign({}, accountBadgeContext),
                        React.createElement(AccountBadgeReissueBulkActionDialog, { onSubmit: (accountSelections) => {
                                close();
                                const accountBadgesToReissue = accountSelections.map((selection) => ({
                                    id: selection.accountBadgeId,
                                    options: selection.options,
                                }));
                                handleReissueAccountBadgesBulkAction(badgeId, accountBadgesToReissue, onSuccess);
                            }, onCancel: () => {
                                close();
                                onClose === null || onClose === void 0 ? void 0 : onClose();
                            }, bulkActionFilters: bulkActionFilters }))));
            },
            onEscapeKeyDown: (close) => close(),
        });
    };
    return {
        handleReissueAccountBadgesBulkAction,
        handleReissueAccountBadgesBulkActionDialog,
    };
}
